//# sourceMappingURL=proposal.mjs.map
/// <reference types="./proposal.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $data_point from "../../../data_types/data/data_point.mjs";
import * as $data_source from "../../../data_types/data/data_source.mjs";
import * as $page from "../../../data_types/data/page.mjs";
import * as $proposal from "../../../data_types/data/proposal.mjs";
import * as $proposal_element from "../../../data_types/data/proposal_element.mjs";
import * as $translate from "../../../data_types/data/translate.mjs";
import * as $language from "../../../data_types/data/translate/language.mjs";
import * as $iso639 from "../../../data_types/data/translate/language/iso639.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $super_admin from "../../admin/effects/super_admin.mjs";
import { apply_org_header } from "../../admin/effects/super_admin.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_proposals(page_index) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Admin(), toList(["proposals"]));
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = $ask.query(
            _pipe$2,
            "page_index",
            $int.to_string(page_index),
          );
          let _pipe$4 = $ask.query(
            _pipe$3,
            "page_size",
            $int.to_string($page.default_page_size),
          );
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $page.page_decoder($decode.list($proposal.decoder())),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (pagination) => {
              let _pipe$6 = pagination;
              let _pipe$7 = new $msg.ApiReturnedProposals(_pipe$6);
              let _pipe$8 = new $msg.Proposal(_pipe$7);
              return dispatch(_pipe$8);
            },
          );
          let _pipe$7 = $ask.on_error(
            _pipe$6,
            (_) => {
              let _pipe$7 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Error fetching proposals",
              );
              return dispatch(_pipe$7);
            },
          );
          return $ask.run(_pipe$7);
        },
      );
    },
  );
}

export function fetch_translations(proposal_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["translations", "proposal", proposal_id, "all"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($translate.translation_decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (translations) => {
              let _pipe$4 = new $msg.ApiReturnedTranslations(
                proposal_id,
                translations,
              );
              let _pipe$5 = new $msg.Proposal(_pipe$4);
              return dispatch(_pipe$5);
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Error fetching translations",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function fetch_proposal_elements(proposal_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["proposals", proposal_id, "elements"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            (() => {
              let elements_decoder = $decode.list($proposal_element.decoder());
              return $decode.field(
                "elements",
                elements_decoder,
                (elements) => {
                  let ds_decoder = $decode.list($data_source.decoder());
                  let ds_decoder$1 = $decode.dict($decode.string, ds_decoder);
                  return $decode.field(
                    "data_sources",
                    ds_decoder$1,
                    (data_sources) => {
                      let dp_decoder = $decode.list($data_point.decoder());
                      let dp_decoder$1 = $decode.dict(
                        $decode.string,
                        dp_decoder,
                      );
                      return $decode.field(
                        "data_points",
                        dp_decoder$1,
                        (data_points) => {
                          return $decode.success(
                            [elements, data_sources, data_points],
                          );
                        },
                      );
                    },
                  );
                },
              );
            })(),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (p) => {
              let elements = p[0];
              dispatch(
                new $msg.Proposal(
                  new $msg.ApiReturnedProposalElements(proposal_id, elements),
                ),
              );
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Error fetching elements",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function retranslate_answers(proposal_id, org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["proposals", proposal_id, "retranslate-answers"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(toList([["org_id", $json.string(org_id)]])),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Retranslation launched for all answers",
              );
              dispatch(_pipe$4);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Error launching retranslation",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

/**
 * Asks for a single missing translation of one element toward one language.
 * `kind` must be `translate.Question` or `translate.Answer`.
 */
export function translate_element(
  proposal_id,
  element_id,
  org_id,
  language,
  kind
) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let label = $string.uppercase($iso639.to_string(language));
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList([
              "proposals",
              proposal_id,
              "elements",
              element_id,
              "translate",
            ]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(
              toList([
                ["org_id", $json.string(org_id)],
                ["language", $iso639.encode(language)],
                [
                  "kind",
                  $json.string($translate.translation_target_to_string(kind)),
                ],
              ]),
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                ("Translation requested (" + label) + ")",
              );
              dispatch(_pipe$4);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                ("Error requesting translation (" + label) + ")",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

/**
 * Asks for every missing question and answer translation of one language across
 * the whole proposal.
 */
export function translate_missing(proposal_id, org_id, language) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let label = $string.uppercase($iso639.to_string(language));
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["proposals", proposal_id, "translate-missing"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(
              toList([
                ["org_id", $json.string(org_id)],
                ["language", $iso639.encode(language)],
              ]),
            ),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                ("Missing " + label) + " translations requested",
              );
              dispatch(_pipe$4);
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                ("Error requesting missing " + label) + " translations",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}
